import React from 'react';
import { Scale } from 'lucide-react';
import { Reveal } from './Reveal';
import { LuxeSeal } from './LuxeSeal';
import { todayPrice } from '../data/valueStack';
export function GuaranteeSection() {
  return <section className="cv-section relative w-full overflow-hidden bg-ink-900 py-14 sm:py-20 md:py-28" data-id="element-49" data-mp="9u38o47kog6z">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_600px_260px_at_50%_50%,rgba(201,162,74,0.08),transparent_70%)]" aria-hidden="true" data-id="element-50" data-mp="euh7qwr74fsv" />
      <Reveal className="relative mx-auto max-w-4xl px-5 sm:px-6" data-id="element-51" data-mp="ntcec9y5jrwp">
        <div className="flex flex-col items-center gap-6 rounded-2xl border border-gold-400/25 bg-gradient-to-b from-ink-800 to-ink-950 p-6 text-center sm:gap-10 sm:p-12 md:flex-row md:gap-12 md:text-left" data-id="element-52" data-mp="skudqtkj1kfk">
          <LuxeSeal data-id="element-53" data-mp="12ja9j9ui1hve" />
          <div data-id="element-54" data-mp="12jti3zy9etwr">
            <span className="inline-flex items-center gap-2 rounded-full border border-gold-400/35 bg-gold-400/[0.07] px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-gold-300" data-id="element-55" data-mp="12kbhv6k4rq9f">
              <Scale className="h-3.5 w-3.5" strokeWidth={1.8} aria-hidden="true" data-id="element-56" data-mp="25sq6uyqpc94z" />
              Garantía "Valor o Muerte"
            </span>
            <h2 className="mt-4 text-[22px] font-extrabold leading-tight tracking-tight text-[#f5f3ee] sm:mt-5 sm:text-3xl" data-id="element-57" data-mp="20v6rtwm6jsbz">
              El riesgo de ser un ignorante es suyo.{' '}
              <span className="gold-text" data-id="element-58" data-mp="1ru8prjvaxuw1">El riesgo financiero es mío.</span>
            </h2>
            <p className="mt-4 text-[14px] leading-relaxed text-[#a7adb8] sm:mt-5 sm:text-[14.5px]" data-id="element-59" data-mp="2ohn152m3n1n7">
              Si no siente que este conocimiento le ha ahorrado al menos{' '}
              <span className="font-semibold text-bone" data-id="element-60" data-mp="2erai5etxngj6">20 veces su costo</span> en la primera
              semana, pida su reembolso. Le devuelvo los ${todayPrice} y puede quedarse con los 15
              bonos como compensación por hacerle perder el tiempo.
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}